// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__-3D1D","actions":"GroupTable_actions__ws1jy","deleteModalFooter":"GroupTable_deleteModalFooter__2Kew_"};